import React, {Fragment} from "react";
import StepQuestion from "components/Step/StepQuestion";
import {Input} from "reactstrap";
import StepInputLabel from "components/Step/StepInputLabel";
import StepButton from "components/Step/StepButton";
import DropdownComponent from "components/DropdownComponent";
import UtilityProvinceService from "services/Util/UtilityProvinceService";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import * as ValidationRule from "utils/ValidationRule";
import StepFeedback from "components/Step/StepFeedback";
import ValidationMethod from "utils/ValidationMethods";
import StepLoadingComponent from "components/Step/StepLoadingComponent";
import StepInformation from "components/Step/StepInformation";


const YUP_RULES = {
    [RegistrationElements.STREET_NUMBER]: ValidationRule.getNumericRule("Street Number", true),
    [RegistrationElements.STREET_NAME]: ValidationRule.getStringRule("Street Name", true),
    [RegistrationElements.TOWN]: ValidationRule.getStringRule("Town/Suburb", true),
    [RegistrationElements.CITY]: ValidationRule.getStringRule("City", true, 3),
    [RegistrationElements.PROVINCE]: ValidationRule.getStringRule("Province", true),
    [RegistrationElements.POSTAL_CODE]: ValidationRule.getPostalCodeRule("Postal Code", true),
};

export default class AddressCaptureStep extends React.Component {

    static PROVINCE_LIST = undefined;
    static loadProvinceList(callback) {
        UtilityProvinceService.retrieveProvinceList().then(response => {
            if(Array.isArray(response)) {
                AddressCaptureStep.PROVINCE_LIST = response;
            }else{
                AddressCaptureStep.PROVINCE_LIST = [];
            }
            if(callback)callback();
        })
    }

    constructor(props, context) {
        super(props, context);

        let validations = [];
        Object.keys(YUP_RULES).forEach(key => [
            validations.push({field: key, yupRule: YUP_RULES[key], value: this.props[key]})
        ]);

        let errors = ValidationMethod.validateInitial(this, validations);
        this.state = {
            loading: true,
            errors: errors
        };
    }

    componentDidMount() {
        if (AddressCaptureStep.PROVINCE_LIST === undefined || AddressCaptureStep.PROVINCE_LIST.length===0) {
            AddressCaptureStep.loadProvinceList(() => {
                this.setState({loading: false});
            });
        } else {
            this.setState({loading: false});
        }
    }

    onChange(e) {
        this.fireChangeEvent(e.target.id, e.target.value);
    }

    fireChangeEvent(key, value) {
        ValidationMethod.validateOnChange(this, key, value);

        if (this.props.onKeyValueChange) {
            this.props.onKeyValueChange(key, value);
        }
    }

    isInvalid(key) {
        return this.state.errors[key] !== undefined && this.state.errors[key].length > 0
    }

    render() {
        if (this.state.loading)
            return <StepLoadingComponent/>
        return <Fragment>

            <StepQuestion>
                Please complete your address information:
            </StepQuestion>

            <StepInputLabel>
                Street Number
                <StepInformation>
                    You need to provide us with a valid South African address.
                </StepInformation>
            </StepInputLabel>
            <Input
                id={RegistrationElements.STREET_NUMBER}
                type={"numeric"}
                className={"small"}
                placeholder={"eg. 164"}
                value={this.props[RegistrationElements.STREET_NUMBER]}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(RegistrationElements.STREET_NUMBER)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.STREET_NUMBER]}
            </StepFeedback>

            <StepInputLabel>
                Street Name
            </StepInputLabel>
            <Input
                id={RegistrationElements.STREET_NAME}
                type={"text"}
                placeholder={"eg. Katherine Street"}
                value={this.props[RegistrationElements.STREET_NAME]}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(RegistrationElements.STREET_NAME)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.STREET_NAME]}
            </StepFeedback>


            <StepInputLabel>
                Town/Suburb
            </StepInputLabel>
            <Input
                id={RegistrationElements.TOWN}
                type={"text"}
                placeholder={"eg. Sandton"}
                value={this.props[RegistrationElements.TOWN]}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(RegistrationElements.TOWN)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.TOWN]}
            </StepFeedback>

            <StepInputLabel>
                City
            </StepInputLabel>
            <Input
                id={RegistrationElements.CITY}
                type={"text"}
                placeholder={"eg. Johannesburg"}
                value={this.props[RegistrationElements.CITY]}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(RegistrationElements.CITY)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.CITY]}
            </StepFeedback>

            <StepInputLabel>
                Province
            </StepInputLabel>
            <DropdownComponent
                id={RegistrationElements.PROVINCE}
                type={"text"}
                className={"step_dropdown"}
                placeholder={"eg. Gauteng"}
                options={AddressCaptureStep.PROVINCE_LIST}
                value={this.props[RegistrationElements.PROVINCE]}
                onChange={(selectedProvince) => {
                    this.fireChangeEvent(RegistrationElements.PROVINCE, selectedProvince ? selectedProvince.value : "")
                }}
                invalid={this.isInvalid(RegistrationElements.PROVINCE)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.PROVINCE]}
            </StepFeedback>

            <StepInputLabel>
                Postal Code
            </StepInputLabel>
            <Input
                id={RegistrationElements.POSTAL_CODE}
                type={"text"}
                className={"small"}
                placeholder={"eg. 1023"}
                value={this.props[RegistrationElements.POSTAL_CODE]}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(RegistrationElements.POSTAL_CODE)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.POSTAL_CODE]}
            </StepFeedback>

            <StepButton
                onClick={this.props.onNextClick}
                disabled={Object.keys(this.state.errors).length > 0}
            >
                {this.props.nextText || "Next"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {this.props.backText || "Back"}
            </StepButton>
        </Fragment>
    }
}